export interface IApMatchHistoryDto {
    id: number;
    actionDate?: Date | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    action?: string | undefined;
    matchingStatus?: string | undefined;
    message?: string | undefined;
}

export class ApMatchHistoryDto implements IApMatchHistoryDto {
    id!: number;
    actionDate?: Date | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    action?: string | undefined;
    matchingStatus?: string | undefined;
    message?: string | undefined;

    static fromJS(data: any): ApMatchHistoryDto {
        const result = new ApMatchHistoryDto();
        if (data) {
            result.id = data['id'];
            result.actionDate = data['actionDate'] ? new Date(data['actionDate']) : undefined;
            result.userId = data['userId'];
            result.userName = data['userName'];
            result.action = data['action'];
            result.matchingStatus = data['matchingStatus'];
            result.message = data['message'];
        }
        return result;
    }
}

export interface IApMatchItemDto {
    id: number;
    jdeIinBin?: string | undefined;
    jdeSellerName?: string | undefined;
    jdeContractNumber?: string | undefined;
    jdeCurrency?: string | undefined;
    exchangeRate?: number | undefined;
    jdeCurrencyAmount?: number | undefined;
    jdeAmountForeignTaxable?: number | undefined;
    jdeAmountForeignTax?: number | undefined;
    jdeAmountTax?: number | undefined;
    jdeAmountTaxable?: number | undefined;
    jdeGlDate?: Date | undefined;
    jdeInvoiceId?: number | undefined;
    esfInvoiceId?: number | undefined;
    esfVatCreditId?: number | undefined;
    jdeAddressNumber?: string | undefined;
    jdeDocumentTypePo?: string | undefined;
    jdePurchaseOrder?: string | undefined;
    jdeBatchNumber?: string | undefined;
    jdeTaxArea?: string | undefined;
    jdeAccountNumber?: string | undefined;
    jdeStatus?: string | undefined;
    jdeSupplierNumber?: string | undefined;
    jdeGrossAmount?: number | undefined;
    jdeServiceDate?: Date | undefined;
    jdeDocumentNumber?: string | undefined;
    jdeType?: string | undefined;
    esfSellerTin?: string | undefined;
    esfSellerName?: string | undefined;
    esfContractNumber?: string | undefined;
    esfTaxArea?: string | undefined;
    esfNetAmount?: number | undefined;
    esfVatCreditRegistrationNumber?: string | undefined;
    esfVatCreditStatus?: string | undefined;
    vatCredit?: any | undefined;
    matchStatus?: string | undefined;
    history?: ApMatchHistoryDto[] | undefined;
    esfDate?: Date | undefined;
    esfTurnoverDate?: Date | undefined;
    esfLastUpdatedDate?: Date | undefined;
    esfCurrency?: string | undefined;
    esfTaxAmount?: number | undefined;
    esfGrossAmount?: number | undefined;
    esfRegistrationNumber?: string | undefined;
    esfNumber?: string | undefined;
    esfStatus?: string | undefined;
    esfType?: string | undefined;
}

export class ApMatchItemDto implements IApMatchItemDto {
    id!: number;
    jdeIinBin?: string | undefined;
    jdeSellerName?: string | undefined;
    jdeContractNumber?: string | undefined;
    jdeCurrency?: string | undefined;
    exchangeRate?: number | undefined;
    jdeCurrencyAmount?: number | undefined;
    jdeAmountForeignTaxable?: number | undefined;
    jdeAmountForeignTax?: number | undefined;
    jdeAmountTax?: number | undefined;
    jdeAmountTaxable?: number | undefined;
    jdeGlDate?: Date | undefined;
    jdeInvoiceId?: number | undefined;
    esfInvoiceId?: number | undefined;
    esfVatCreditId?: number | undefined;
    jdeAddressNumber?: string | undefined;
    jdeDocumentTypePo?: string | undefined;
    jdePurchaseOrder?: string | undefined;
    jdeBatchNumber?: string | undefined;
    jdeTaxArea?: string | undefined;
    jdeAccountNumber?: string | undefined;
    jdeStatus?: string | undefined;
    jdeSupplierNumber?: string | undefined;
    jdeGrossAmount?: number | undefined;
    jdeServiceDate?: Date | undefined;
    jdeDocumentNumber?: string | undefined;
    jdeType?: string | undefined;
    esfSellerTin?: string | undefined;
    esfSellerName?: string | undefined;
    esfContractNumber?: string | undefined;
    esfTaxArea?: string | undefined;
    esfNetAmount?: number | undefined;
    esfVatCreditRegistrationNumber?: string | undefined;
    esfVatCreditStatus?: string | undefined;
    vatCredit?: any | undefined;
    matchStatus?: string | undefined;
    history?: ApMatchHistoryDto[] | undefined;
    esfDate?: Date | undefined;
    esfTurnoverDate?: Date | undefined;
    esfLastUpdatedDate?: Date | undefined;
    esfCurrency?: string | undefined;
    esfTaxAmount?: number | undefined;
    esfGrossAmount?: number | undefined;
    esfRegistrationNumber?: string | undefined;
    esfNumber?: string | undefined;
    esfStatus?: string | undefined;
    esfType?: string | undefined;
    jdeAmountTaxKzt?: number | undefined;

    static fromJS(data: any): ApMatchItemDto {
        const result = new ApMatchItemDto();
        if (data) {
            result.id = data['id'];
            result.jdeIinBin = data['jdeIinBin'];
            result.jdeSellerName = data['jdeSellerName'];
            result.jdeContractNumber = data['jdeContractNumber'];
            result.jdeCurrency = data['jdeCurrency'];
            result.exchangeRate = data['exchangeRate'];
            result.jdeCurrencyAmount = data['jdeCurrencyAmount'];
            result.jdeAmountForeignTaxable = data['jdeAmountForeignTaxable'];
            result.jdeAmountForeignTax = data['jdeAmountForeignTax'];
            result.jdeAmountTax = data['jdeAmountTax'];
            result.jdeAmountTaxable = data['jdeAmountTaxable'];
            result.jdeGlDate = data['jdeGlDate'] ? new Date(data['jdeGlDate']) : undefined;
            result.jdeInvoiceId = data['jdeInvoiceId'];
            result.esfInvoiceId = data['esfInvoiceId'];
            result.esfVatCreditId = data['esfVatCreditId'];
            result.jdeAddressNumber = data['jdeAddressNumber'];
            result.jdeDocumentTypePo = data['jdeDocumentTypePo'];
            result.jdePurchaseOrder = data['jdePurchaseOrder'];
            result.jdeBatchNumber = data['jdeBatchNumber'];
            result.jdeTaxArea = data['jdeTaxArea'];
            result.jdeAccountNumber = data['jdeAccountNumber'];
            result.jdeStatus = data['jdeStatus'];
            result.jdeSupplierNumber = data['jdeSupplierNumber'];
            result.jdeGrossAmount = data['jdeGrossAmount'];
            result.jdeServiceDate = data['jdeServiceDate'] ? new Date(data['jdeServiceDate']) : undefined;
            result.jdeDocumentNumber = data['jdeDocumentNumber'];
            result.jdeType = data['jdeType'];
            result.esfSellerTin = data['esfSellerTin'];
            result.esfSellerName = data['esfSellerName'];
            result.esfContractNumber = data['esfContractNumber'];
            result.esfTaxArea = data['esfTaxArea'];
            result.esfNetAmount = data['esfNetAmount'];
            result.esfVatCreditRegistrationNumber = data['esfVatCreditRegistrationNumber'];
            result.esfVatCreditStatus = data['esfVatCreditStatus'];
            result.vatCredit = data['vatCredit'];
            result.matchStatus = data['matchStatus'];
            if (Array.isArray(data['history'])) {
                result.history = data['history'].map((item: any) => ApMatchHistoryDto.fromJS(item));
            }
            result.esfDate = data['esfDate'] ? new Date(data['esfDate']) : undefined;
            result.esfTurnoverDate = data['esfTurnoverDate'] ? new Date(data['esfTurnoverDate']) : undefined;
            result.esfLastUpdatedDate = data['esfLastUpdatedDate'] ? new Date(data['esfLastUpdatedDate']) : undefined;
            result.esfCurrency = data['esfCurrency'];
            result.esfTaxAmount = data['esfTaxAmount'];
            result.esfGrossAmount = data['esfGrossAmount'];
            result.esfRegistrationNumber = data['esfRegistrationNumber'];
            result.esfNumber = data['esfNumber'];
            result.esfStatus = data['esfStatus'];
            result.esfType = data['esfType'];
            result.jdeAmountTaxKzt = data['jdeAmountTaxKzt'];
        }
        return result;
    }
}

export interface IGetApMatchesResponseDto {
    matchItems?: ApMatchItemDto[] | undefined;
    paging?: { totalRecords: number; currentPage: number; itemsPerPage: number; pageCount: number } | undefined;
}

export class GetApMatchesResponseDto implements IGetApMatchesResponseDto {
    matchItems?: ApMatchItemDto[] | undefined;
    paging?: { totalRecords: number; currentPage: number; itemsPerPage: number; pageCount: number } | undefined;

    static fromJS(data: any): GetApMatchesResponseDto {
        const result = new GetApMatchesResponseDto();
        if (data) {
            if (Array.isArray(data['matchItems'])) {
                result.matchItems = data['matchItems'].map((item: any) => ApMatchItemDto.fromJS(item));
            }
            result.paging = data['paging'];
        }
        return result;
    }
}
